import { HEADER } from '_constants';

const setHeader = (settings) => (dispatch, getState) => {
  dispatch({ type: HEADER.UPDATE_HEADER, payload: settings });
};

export const headerActions = {
  setHeader
};

export const toggleReadLoader = (isLoading) => (dispatch) => {
  dispatch({ type: HEADER.TOGGLE_READ_LOADER, isLoadingRead: isLoading });
};

export const toggleWriteLoader = (isLoading) => (dispatch) => {
  dispatch({ type: HEADER.TOGGLE_WRITE_LOADER, isLoadingWrite: isLoading });
};
